var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.3477C13.0052 19.3477 14.724 18.6315 16.1562 17.1992C17.6172 15.7383 18.3477 14.0052 18.3477 12C18.3477 11.3125 18.1901 10.5247 17.875 9.63672C17.5885 8.7487 17.2305 8.03255 16.8008 7.48828L6.48828 17.8008C7.77734 18.832 9.28125 19.3477 11 19.3477ZM3.65234 12C3.65234 12.6875 3.79557 13.4753 4.08203 14.3633C4.39714 15.2513 4.76953 15.9674 5.19922 16.5117L15.5117 6.19922C14.2227 5.16797 12.7188 4.65234 11 4.65234C8.99479 4.65234 7.26172 5.38281 5.80078 6.84375C4.36849 8.27604 3.65234 9.99479 3.65234 12ZM4.51172 5.55469C6.31641 3.75 8.47917 2.84766 11 2.84766C13.5208 2.84766 15.6693 3.75 17.4453 5.55469C19.25 7.33073 20.1523 9.47917 20.1523 12C20.1523 14.5208 19.25 16.6836 17.4453 18.4883C15.6693 20.2643 13.5208 21.1523 11 21.1523C8.47917 21.1523 6.31641 20.2643 4.51172 18.4883C2.73568 16.6836 1.84766 14.5208 1.84766 12C1.84766 9.47917 2.73568 7.33073 4.51172 5.55469Z",
    fill: "#9497A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedIcon);
export default __webpack_public_path__ + "static/media/blocked_icon.e76b69711b0deebd1d6453eb7219fb87.svg";
export { ForwardRef as ReactComponent };